import React from 'react';
import styles from './SubCategorySelector.module.scss';
import { SubCategory } from '../../../types/projectDocumentation';
import { ArrowLeft } from 'lucide-react';
import CheckIcon from '../../../assets/iconsTsx/CheckIcon.tsx';

interface SubCategorySelectorProps {
  subCategories: SubCategory[];
  selectedSubCategory: string | null;
  onSelect: (subCategoryId: string) => void;
  onBack: () => void;
  loading?: boolean;
}

const SubCategorySelector: React.FC<SubCategorySelectorProps> = ({
  subCategories,
  selectedSubCategory,
  onSelect,
  onBack,
  loading = false
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerText}>
          <h2 className={styles.title}>Selecciona una subcategoría</h2>
          <p className={styles.description}>
            Elige la subcategoría específica para tu anteproyecto
          </p>
        </div>
        <button className={styles.backButton} onClick={onBack}>
          <ArrowLeft size={16} />
          Volver
        </button>
      </div>

      {loading ? (
        <div className={styles.loadingState}>
          <div className={styles.spinner}></div>
          <p>Cargando subcategorías...</p>
        </div>
      ) : (
        <>
          <div className={styles.subCategoriesGrid}>
            {subCategories.map((subCategory) => (
              <div
                key={subCategory.id}
                className={`${styles.subCategoryCard} ${
                  selectedSubCategory === subCategory.id ? styles.selected : ''
                }`}
                onClick={() => onSelect(subCategory.id)}
              >
                <div className={styles.subCategoryIcon}>
                  <div className={styles.iconPlaceholder}>
                    {subCategory.name.charAt(0).toUpperCase()}
                  </div>
                </div>
                <h3 className={styles.subCategoryName}>{subCategory.name}</h3>
                {selectedSubCategory === subCategory.id && (
                  <div className={styles.checkmark}>
                    <CheckIcon className={styles.checkIcon} />
                  </div>
                )}
              </div>
            ))}
          </div>

          {subCategories.length === 0 && !loading && (
            <div className={styles.emptyState}>
              <p>No hay subcategorías disponibles para esta categoría</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SubCategorySelector;
